import React from 'react';
import {
    Card, Button, Icon, Col, Row,
} from 'antd';

export default function AddressBox(props) {
    const {
        address, index, onEditClick, onDeleteClick,
    } = props;
    const {
        address_name, city, country, line_1, line_2, pin_code, state, id,
    } = address;

    return (
        <div
            style={{
                display: 'inline-block',
            }}
        >
            <Card
                title={address_name == null ? '---' : address_name}
                bordered
                style={{
                    width: '350px', height: '300px', padding: '10px', margin: '10px',
                }}
                extra={(
                    <div>
                        <Button
                            style={{ margin: '5px' }}
                            type="primary"
                            onClick={() => onEditClick(index)}
                        >
                            <Icon type="edit" />
                        </Button>

                        <Button
                            type="danger"
                            onClick={() => onDeleteClick(id, index)}
                        >
                            <Icon type="delete" />
                        </Button>
                    </div>

                )}

            >
                <div style={{ textAlign: 'left' }}>
                    <Row>
                        <Col>
                            <p style={{ fontSize: '16px' }}>{line_1}</p>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <p style={{ fontSize: '16px' }}>{line_2}</p>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <p style={{ fontSize: '16px' }}>{`${city}, ${pin_code}`}</p>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <p style={{ fontSize: '16px' }}>{`${state}, ${country}`}</p>
                        </Col>
                    </Row>

                </div>

            </Card>
        </div>

    );
}



// WEBPACK FOOTER //
// ./src/component/Users/AddressBox.js